import React, { useContext } from "react";
import classnames from "classnames";
import Styles from "./TestimonialCard.module.scss";
import AppImg from "components/utils/AppImg";
import { AppContext } from "@vahak/core/dist/app-context";

import QuotationMarksBlue from "@vahak/core/dist/icons/quotation_marks_blue.svg";

interface DataProps {
    id: number;
    name: string;
    company: string;
    location: string;
    massage: string;
    srcset: string;
    image: string;
}

interface TestimonialCardProps {
    data: DataProps;
    width: number;
}

const TestimonialCard = ({ data, width }: TestimonialCardProps) => {
    const { isMobile } = useContext(AppContext);
    const cardStagePaddinglr = 296;
    const cardMarginlr = 16;
    const cardWidth = width - (cardStagePaddinglr + cardMarginlr);

    return (
        <div className={Styles.customerSaysRow} style={{ width: `${isMobile ? width : cardWidth}px` }}>
            <div className={classnames(Styles.imgBox)}>
                <AppImg src={data.image} alt={data.name} layout="responsive" width="538" height="517" />
            </div>
            <div className={classnames(Styles.textCol)}>
                <QuotationMarksBlue />
                <p>{data.massage}</p>
                <h5>
                    {data.name}
                    {data.location && ", " + data.location}
                </h5>
                <h6>{data.company}</h6>
            </div>
        </div>
    );
};

export default TestimonialCard;
